import GetSafetyAnchorPointsRequestModelBase from '../_generated/modelBases/get-safety-anchor-points-request-model-base';

export default class GetSafetyAnchorPointsRequestModel extends GetSafetyAnchorPointsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
